<template>

    <div class="checkbox">
        <input type="checkbox" v-model="val">
        <span class="checkmark" @click.stop="toggle">
            <i class="icon fas fa-check"></i>
        </span>
        <span v-if="label" class="label" @click.stop="toggle">{{ label }}</span>
    </div>

</template>

<style scoped lang="scss">

    .checkbox {

        align-items: center;
        display: flex;
        position: relative;
        z-index: 0;

        input {
            height: 0;
            line-height: 0;
            opacity: 0;
            width: 0;
        }

        .checkmark {
            align-items: center;
            background-color: $color-bg;
            border: 1px solid $color-rule;
            border-radius: 3px;
            box-sizing: border-box;
            cursor: pointer;
            display: flex;
            justify-content: center;
            flex-shrink: 0;
            height: 18px;
            line-height: normal;
            margin: 0;
            padding: 0;
            position: relative;
            transition: border-color .3s;
            width: 18px;
            .icon {
                color: #fff;
                display: none;
                font-size: 10px;
            }
        }

        .label {
            @include font-medium(13px);
            line-height: normal;
            margin-left: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            user-select: none;
            white-space: nowrap;
        }

        &:hover .checkmark {
            border-color: $color-text;
        }

        input:checked ~ .checkmark {
            background-color: $color-primary;
            border-color: $color-primary;
            .icon {
                display: block;
            }
        }

    }

</style>

<script>

export default {

    props: {
        model: {
            required: true,
        },
        label: {
            type: String,
        },
    },

    data() {
        return {
            val: this.model,
        }
    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

    methods: {

        toggle() {
            this.val = !this.val;
        },

    },

}

</script>
